<section *ngFor="let chapter of chapterInfo.chapters; let i = index" [ngClass]="styles.wrapper">
	<div [ngClass]="styles.chapterWrapper">
		<a class="slide-row" layout="row" layout-wrap="false" [ngClass]="[styles.chapter, chapter === chapterInfo.currentChapter ? 'theme-accent' : '']" (click)="clickChapter(chapter, i)">
			<span [ngClass]="styles.title" flex="fill">{{chapter.title}}</span>
			<span [ngClass]="styles.time"> {{chapter.time | vbTimespan}} </span>
		</a>
	</div>
</section>